import { render, staticRenderFns } from "./ChannelsCategorySelectionDialog.vue?vue&type=template&id=29f167d4"
import script from "./ChannelsCategorySelectionDialog.vue?vue&type=script&lang=js"
export * from "./ChannelsCategorySelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports